<div class="row padding-top">
    <div class="col-md-6 col-sm-12">
        <mat-form-field class="full-width">
            <mat-label>{{'DISCOUNT_CODE.PROMOTIONAL_CODE' | translate}}</mat-label>
            <input matInput [(ngModel)]="inputPromotionnalCode" name="discountInput" class="full-width" type="text"
                size="20" autocomplete="off">
        </mat-form-field>
    </div>
    <div class="col-md-6 col-sm-12">
        <button mat-raised-button name="discountButton" class="mat-raised-button full-width"
            [disabled]="!inputPromotionnalCode" (click)="validate()">
            {{'DISCOUNT_CODE.VALIDATE_CODE' | translate}}
        </button>
    </div>
</div>